<template>
    <div class="phone-wrap">
        <!--  告警详情弹框 -->
        <a-modal
            centered
            title='告警详情'
            :width="800"
            :confirmLoading="confirmLoading"
            :visible="visible"
            @cancel="closeModal"
            >
            <div class="mb16">
                <a-row>
                    <a-col :span="10">告警时间：{{detailData.warnTime || '--'}}</a-col>
                    <a-col :span="7">告警类型：{{['儿童告警','进出场告警'][detailData.warnType] || '--'}}</a-col>
                    <a-col :span="7">告警项：{{['儿童出场告警','设备非法出场告警','非法设备进场告警','超时未入场告警'][detailData.warnOption] || '--'}}</a-col>
                </a-row>
                <a-row>
                    <a-col :span="10">设备ID：{{detailData.deviceId || '--'}}</a-col>
                    <a-col :span="7">绑定用户：{{detailData.account || '--'}}</a-col>
                    <a-col :span="7">绑定手机号：{{detailData.mobile || '--'}}</a-col>
                </a-row>
                <a-row>
                    <a-col :span="10">告警状态：{{['未处理','已处理'][detailData.status] || '--'}}</a-col>
                    <a-col :span="7">操作人：{{detailData.operator || '--'}}</a-col>
                    <a-col :span="7">操作时间：{{detailData.updateTime || '--'}}</a-col>
                </a-row>
            </div>
            <a-alert :message="'告警门店：' + detailData.shopName + '； 告警时坐标：'+(detailData.warnCoodix || '--')+', ' +(detailData.warnCoodiy || '--')+ '； 告警时区域：'+(detailData.warnArea || '--')" type="warning" >
                <div slot="description" v-if="detailData.warnOption != 3 && detailData.sendSmsTime">
                    <a-icon type="message" /> 
                    <span> {{detailData.sendSmsTime}} 已发送</span> 
                </div>
                <div slot="description" v-if="detailData.warnOption == 3">
                    <div>绑定时间：{{detailData.bindTime || '--'}}</div>
                    <div>超时未入场：超过限定时间{{Math.round(($moment(detailData.inTime)-$moment(detailData.bindTime))/60000)}}分钟</div>
                </div>
            </a-alert>
            <div :class="'map_box' + detailData.shopId" v-if="detailData.warnOption != 3">
                <img v-if="detailData.warnArea" :style="{left: PX + 'px', bottom: PY + 'px'}" preview src="../../../assets/image/map_02.png" alt="">
            </div>
            <template slot="footer">
                <a-button v-if="detailData.status" @click="closeModal">关闭</a-button>
                <a-button v-else @click="closeModal">取消</a-button>
                <a-button v-if="!detailData.status" @click="handleCreate" type="primary">知道并已处理</a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>

    /**
     * 告警详情弹框组件
     * @prop {Boolean} visiblePhone 控制弹窗是否显示
     *
     * @func closeModalPhone 通知父组件关闭弹窗
     *
     */
    export default {
        name: "member-order-phone",
        zh: "告警详情弹框组件",
        data() {
            return {
                confirmLoading: false,
                detailData: {},
                PX: 0,
                PY: 0,
                shop: [{
                    shopId: 8,
                    o_width: 140.325,
                    o_height: 64.6,
                    image_width: 753,
                    image_height: 360,
                    origin_x: 0,
                    origin_y: 154,
                }, {
                    shopId: 12,
                    o_width: 71.05,
                    o_height: 34.835,
                    image_width: 753,
                    image_height: 373,
                    origin_x: 430,
                    origin_y: 174,
                }, {
                    shopId: 9,
                    o_width: 77.20,
                    o_height: 21.995,
                    image_width: 753,
                    image_height: 218.3,
                    origin_x: 311,
                    origin_y: 18,
                }, {
                    shopId: 11,
                    o_width: 58.82,
                    o_height: 69.575,
                    image_width: 753,
                    image_height: 887,
                    origin_x: 574,
                    origin_y: 184,
                }, {
                    shopId: 10,
                    o_width: 78.62,
                    o_height: 60.5,
                    image_width: 753,
                    image_height: 584,
                    origin_x: 730,
                    origin_y: 574,
                }, {
                    shopId: 14,
                    o_width: 70.15,
                    o_height: 35,
                    image_width: 753,
                    image_height: 374,
                    origin_x: -20,
                    origin_y: 364,
                }, {
                    shopId: 13,
                    o_width: 62.135,
                    o_height: 47.55,
                    image_width: 753,
                    image_height: 605.8,
                    origin_x: -16,
                    origin_y: -8,
                }, {
                    shopId: 15,
                    o_width: 48.91,
                    o_height: 44.855,
                    image_width: 753,
                    image_height: 688.9,
                    origin_x: 42,
                    origin_y: 247,
                }, {
                    shopId: 16,
                    o_width: 29.696,
                    o_height: 32.344,
                    image_width: 753,
                    image_height: 834.78,
                    origin_x: 114,
                    origin_y: 400,
                }, {
                    shopId: 17,
                    o_width: 33.9,
                    o_height: 54.2,
                    image_width: 753,
                    image_height: 1185.77,
                    origin_x: 568.35,
                    origin_y: 565.7,
                }],
            };
        },
        props: {
            id: {type: String},
            visible: {type: Boolean},
        },
        methods: {
            getDetial() {
                this.$api.wrist.warnDetail({
                    params: {
                        id: this.id,
                    }
                }).then(res => {
                    this.detailData = res;
                    this.shop.forEach(el => {
                        if (el.shopId == res.shopId) {
                            this.PX = el.origin_x + res.warnCoodix * el.image_width / el.o_width;
                            this.PY = el.origin_y + res.warnCoodiy * el.image_height / el.o_height;
                        }
                    });
                    
                });
            },
            handleCreate() {
                this.confirmLoading = true
                this.$api.wrist.warnState({
                    body: {
                        id: this.id,
                        status: 1,
                        operator: this.$userInfoTool.getUser().name,
                        operatorId: this.$userInfoTool.getUser().id,
                        shopId: this.detailData.shopId
                    }
                }).then(res => {
                    this.confirmLoading = false;
                    this.$message.success('操作成功');
                    this.closeModal();
                });
            },
            closeModal() {
                this.$emit('changeVisible', false)
            },
        },
        beforeCreate() {
        },
        created() {},
        updated() {},
        mounted() {},
        computed: {},
        watch: {
            'visible'(val) {
                if(val) {
                    this.getDetial()
                }
            }
        }
    };
</script>

<style lang="scss">
.map_box8 {
    position: relative;
    margin-top: 16px;
    height: 360px;
    background: url('../../../assets/image/shop8-1.png') no-repeat;
    background-size: 752px 343px;
    >img {
        position: absolute;
        width: 40px;
        height: 44px;
    }
}
.map_box12 {
    position: relative;
    margin-top: 16px;
    height: 373px;
    background: url('../../../assets/image/shop12-1.png') no-repeat;
    background-size: 752px 373px;
    >img {
        position: absolute;
        width: 40px;
        height: 44px;
    }
}
.map_box9 {
    position: relative;
    margin-top: 16px;
    height: 218px;
    background-image: url('../../../assets/image/shop9-1.png');
    background-size: 752px 218px;
    >img {
        position: absolute;
        width: 40px;
        height: 44px;
    }
}
.map_box14 {
    position: relative;
    margin-top: 16px;
    height: 374px;
    background-image: url('../../../assets/image/shop14-1.png');
    background-size: 752px 374px;
    >img {
        position: absolute;
        width: 40px;
        height: 44px;
    }
}
.map_box10 {
    position: relative;
    margin-top: 16px;
    height: 584px;
    background-image: url('../../../assets/image/shop10-1.png');
    background-size: 752px 584px;
    >img {
        position: absolute;
        width: 40px;
        height: 44px;
    }
}

.map_box11 {
    position: relative;
    margin-top: 16px;
    height: 887px;
    background-image: url('../../../assets/image/shop11-1.png');
    background-size: 752px 887px;
    >img {
        position: absolute;
        width: 40px;
        height: 44px;
    }
}
.map_box13 {
    position: relative;
    margin-top: 16px;
    height: 606px;
    background-image: url('../../../assets/image/shop13-1.png');
    background-size: 752px 606px;
    >img {
        position: absolute;
        width: 40px;
        height: 44px;
    }
}
.map_box15 {
    position: relative;
    margin-top: 16px;
    height: 689px;
    background-image: url('../../../assets/image/shop15-2.png');
    background-size: 752px 689px;
    >img {
        position: absolute;
        width: 40px;
        height: 44px;
    }
}
.map_box16 {
    position: relative;
    margin-top: 16px;
    height: 835px;
    background-image: url('../../../assets/image/shop16-1.png');
    background-size: 752px 835px;
    >img {
        position: absolute;
        width: 40px;
        height: 44px;
    }
}
.map_box17 {
    position: relative;
    margin-top: 16px;
    height: 1185px;
    background-image: url('../../../assets/image/shop17-1.png');
    background-size: 752px 1185px;
    >img {
        position: absolute;
        width: 40px;
        height: 44px;
    }
}
</style>